import { post } from "../api.helper";
import * as URL from "../url.helper";

export const callUserSignUp = data => post(URL.SIGN_UP, data, {skipInterceptor: true});
export const callVerifySignUp = data => post(URL.VERIFY_OTP, data, {skipInterceptor: true});
export const callResendOTP = data => post(URL.RE_SEND_OTP, data, {skipInterceptor: true});

export const addPartnerEnquiry = data => post(URL.ADD_PARTNER_ENQUIRY, data, { skipInterceptor: true });